//MUI
import CreateIcon from '@mui/icons-material/Create';

//selectors for redux :
import { useDispatch } from "react-redux";
import { shoppingStepSlice } from "../../../../store/shoppingStepSlice.js";
import { contratStepSlice } from "../../../../store/contratStepSlice.js";

function BlocRecap({ step, titre, infos, edit }) { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

    const dispatch = useDispatch();

    function handlePenClick() {
        dispatch(shoppingStepSlice.actions.goToShoppingStep(step));
        // ManagerMode :
        dispatch(contratStepSlice.actions.goToContratStep(step));

    }

    return (
        <div className="bloc-recap">
            <div className="bloc-recap-left"></div>

            <div className="bloc-recap-right">
                <div className="bloc-recap-right-header">
                    <h2>{titre}</h2>
                    {edit === true ?
                        <CreateIcon className="pen-icon" onClick={handlePenClick} />
                        : null}
                </div>
                <div className="bloc-recap-right-body">
                    {infos /* component sent as prop */}
                </div>
            </div>

        </div>

    )
}


export default BlocRecap